import { Component } from '@angular/core';
import { environment } from '../environments/environment';
import {Router} from "@angular/router"
import { InfoUsuarioService } from './core/services/info-usuario.service';
import { AutenticacionService } from './core/services/autenticacion.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent
{
  constructor(private autenticacionService: AutenticacionService, private infoUsuarioService: InfoUsuarioService) { }
  value: Date;
  env = environment;
  usuarioAutenticado = false;

  ngOnInit(): void
  {
    this.usuarioAutenticado = this.infoUsuarioService.usuarioLogueado();

    this.autenticacionService.autenticacionCambio
      .subscribe(res =>
      {
        this.usuarioAutenticado = res;
      })
  }
}


